import { render, staticRenderFns } from "./AddTip.vue?vue&type=template&id=c44f9662&scoped=true"
import script from "./AddTip.vue?vue&type=script&lang=js"
export * from "./AddTip.vue?vue&type=script&lang=js"
import style0 from "./AddTip.vue?vue&type=style&index=0&id=c44f9662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44f9662",
  null
  
)

export default component.exports